export default __webpack_public_path__ + "static/media/Cigarettes.1ae900d5.png";